import { store } from "../store";
import { resolveLanguage } from "./language";

export function getSignalingUrl(token, presenceStatus) {
  const hostname = window.config.messagingRTCServiceUrl;
  const language = resolveLanguage(store.getState().user.userLanguage);

  return `wss://${hostname}/?token=${token}&userLanguage=${language}&presenceStatus=${presenceStatus}`;
}
